import React, { Component } from 'react'
import PropTypes from 'prop-types'

class PointsInformation extends Component {
  render () {
    return (
      <span
        className={`${window.localStorage.getItem('hideValue') === 'true' || this.props.hideValue ? 'hide-points' : ''}`}
        aria-hidden={window.localStorage.getItem('hideValue') === 'true' || this.props.hideValue}>
        {window.localStorage.getItem('hideValue') === 'true' || this.props.hideValue ? (
          this.props.maskedValue
        ) : (
          this.props.formatPoints
        )}
      </span>
    )
  }
}

PointsInformation.propTypes = {
  hideValue: PropTypes.bool,
  maskedValue: PropTypes.func,
  formatPoints: PropTypes.func
}

export default PointsInformation



// WEBPACK FOOTER //
// ./src/App/Header/UserBasicInformation/PointsInformation.js